import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from '../../helpers/api/apiCore';

// helpers
import { login as loginApi, logout as logoutApi, forgotPassword as forgotPasswordApi } from '../../helpers/';

// actions
import { authApiResponseSuccess, authApiResponseError } from './actions';

// constants
import { AuthActionTypes } from './constants';

type UserData = {
    payload: {
        username: string;
        password: string;
        fullname: string;
        email: string;
        token?: string;
    };
    type: string;
};

const api = new APICore();

/**
 * Login the user
 * @param {*} payload - username and password
 */
// function* login({ payload: { email, password }, type }: UserData): SagaIterator {
//     try {
//         const response = yield call(loginApi, { email, password });
//         const user = response.data;
//         // NOTE - You can change this according to response format from your api
//         api.setLoggedInUser(user);
//         setAuthorization(user['token']);
//         yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
//     } catch (error: any) {
//         yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
//         api.setLoggedInUser(null);
//         setAuthorization(null);
//     }
// }

function* login({ payload: { email, password }, type }: UserData): SagaIterator {
    try {
        const response = yield call(api.create, '/auth/login', {
            email: email,
            password: password,
        });

        const user = response.data;

        if (user.hasOwnProperty('error')) {
            yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, user.message));
            api.setLoggedInUser(null);
            setAuthorization(null);
        } else {
            console.log('no error   ');
            const token = user['token'] || user['access_token'];
            // Normalize the user object to always have 'token' if needed by other parts of the app
            if (!user['token'] && token) {
                user['token'] = token;
            }
            api.setLoggedInUser(user);
            setAuthorization(token);
            yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
        }
    } catch (error: any) {
        console.error('Login error:', error);
        yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error || 'Something went wrong'));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

/**
 * Logout the user
 */
function* logout(): SagaIterator {
    try {
        yield call(logoutApi);
        api.setLoggedInUser(null);
        setAuthorization(null);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGOUT_USER, {}));
    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.LOGOUT_USER, error));
    }
}

function* forgotPassword({ payload: { email } }: UserData): SagaIterator {
    try {
        const response = yield call(forgotPasswordApi, { email });
        yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD, response.data));
    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD, error));
    }
}

function* resetPasswordSaga({ payload: { email, token, password } }: UserData): SagaIterator {
    try {
        const response = yield call(api.create, '/auth/validate-token', {
            email,
            token,
            password,
        });
        yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD_CHANGE, response.data));
    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD_CHANGE, error));
    }
}
export function* watchLoginUser() {
    yield takeEvery(AuthActionTypes.LOGIN_USER, login);
}

export function* watchLogout() {
    yield takeEvery(AuthActionTypes.LOGOUT_USER, logout);
}

export function* watchForgotPassword(): any {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD, forgotPassword);
}

export function* watchResetPassword(): any {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD_CHANGE, resetPasswordSaga);
}

function* authSaga() {
    yield all([fork(watchLoginUser), fork(watchLogout), fork(watchForgotPassword), fork(watchResetPassword)]);
}

export default authSaga;
